import React from 'react';
import { Alert, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const NoteRuleNudge = ({ onClose }) => {
  const { t } = useTranslation();

  const buttonStyle = {
    height: '32px',
    padding: '4px 15px',
    display: 'flex',
    alignItems: 'center'
  };

  const handleAddRule = () => {
    onClose();
    window.open('/preferences', '_blank', 'noopener,noreferrer');
  };

  return (
    <Alert
      message={t('session_notes.nudge.title', 'Add a Note Rule')}
      description={
        <div>
          <div style={{ marginBottom: '16px' }}>
            {t('session_notes.nudge.description', 'Would you like to create a rule based on this note? This can help automate similar notes in the future.')}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button 
              size="small" 
              type="primary" 
              style={buttonStyle}
              onClick={handleAddRule}
            >
              {t('session_notes.nudge.add_rule', 'Add Rule')}
            </Button>
          </div>
        </div>
      }
      type="success"
      action={
        <Button 
          size="small" 
          icon={<CloseOutlined />} 
          onClick={onClose}
        />
      }
      style={{ 
        marginBottom: '20px',
        width: '100%',
        borderRadius: '8px'
      }}
    />
  );
};

export default NoteRuleNudge; 